import { ApiBase } from "~/extensions/api";
import { FindInformationListCommand } from "./commands/FindInfomationListCommand";
import { GetInformationCommand } from "./commands/GetInformationCommand";
import { UpdateInformationCommand } from "./commands/UpdateInformationCommand";
export class InformationApi extends ApiBase {
    /**検索API */
    find() {
        let command = new FindInformationListCommand();
        return this.request(command);
    }
    /**取得API */
    get(informationNo) {
        let command = new GetInformationCommand(informationNo);
        return this.request(command);
    }
    /**回答API */
    update(model) {
        let command = new UpdateInformationCommand(model);
        return this.request(command);
    }
}
